
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class MatrixRainEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);

        ctx.font = `${(12 + (config.parallaxLayers - layerIndex) * 4) * (config.parallaxScale || 1.0)}px monospace`;
        ctx.fillStyle = pc.color;
        const chars = "0123456789ABCDEFHIJKLMNOPQRSTUVWXYZ$@#%&*";

        for (let x = x1; x <= x2; x += spacing / 2) {
            const speed = (0.5 + this.pseudoRandom(x) * 1.5) * config.parallaxSpeed;
            const offset = (time * 100 * speed) % spacing;
            
            for (let y = y1; y <= y2; y += spacing / 3) {
                const char = chars[Math.floor(this.pseudoRandom(x + y + Math.floor(time * 10)) * chars.length)];
                
                const draw = () => {
                    ctx.fillText(char, x, y + offset);
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
